import classNames from 'classnames';
import { ReactNode } from 'react';

interface ContainerProps {
  children: ReactNode;
  className?: string;
}

export function Container({ children, className }: ContainerProps) {
  return <div className={classNames('mx-auto max-w-screen-xl px-4', className)}>{children}</div>;
}
